import { useAtom } from "jotai";
import React, { useEffect, useState } from "react";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { useLocation, useNavigate } from "react-router-dom";
import { getAllCategories } from "../../firebase/categories";
import { priceRangeAtom, searchParamsAtom, yearRangeAtom } from "../../store";
import { boxTypes, conditions } from "../../utils/data";

const CheckedIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_651_77"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_651_77)">
      <path
        d="M8.83333 13.5L14.7083 7.625L13.5417 6.45833L8.83333 11.1667L6.45833 8.79167L5.29167 9.95833L8.83333 13.5ZM4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H4.16667Z"
        fill="#B1CCFF"
      />
    </g>
  </svg>
);

const UnCheckedIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.3">
      <mask
        id="mask0_651_92"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_651_92)">
        <path
          d="M4.42345 17.0837C4.00248 17.0837 3.64616 16.9378 3.35449 16.6462C3.06283 16.3545 2.91699 15.9982 2.91699 15.5772V4.42345C2.91699 4.00248 3.06283 3.64616 3.35449 3.35449C3.64616 3.06283 4.00248 2.91699 4.42345 2.91699H15.5772C15.9982 2.91699 16.3545 3.06283 16.6462 3.35449C16.9378 3.64616 17.0837 4.00248 17.0837 4.42345V15.5772C17.0837 15.9982 16.9378 16.3545 16.6462 16.6462C16.3545 16.9378 15.9982 17.0837 15.5772 17.0837H4.42345ZM4.42345 15.8337H15.5772C15.6414 15.8337 15.7001 15.8069 15.7535 15.7535C15.8069 15.7001 15.8337 15.6414 15.8337 15.5772V4.42345C15.8337 4.35928 15.8069 4.30053 15.7535 4.2472C15.7001 4.19373 15.6414 4.16699 15.5772 4.16699H4.42345C4.35928 4.16699 4.30053 4.19373 4.2472 4.2472C4.19373 4.30053 4.16699 4.35928 4.16699 4.42345V15.5772C4.16699 15.6414 4.19373 15.7001 4.2472 15.7535C4.30053 15.8069 4.35928 15.8337 4.42345 15.8337Z"
          fill="white"
        />
      </g>
    </g>
  </svg>
);

const SidebarFilterMarketplaceCategories = ({ className, show }) => {
  // State to control open/close for each category
  const [openSections, setOpenSections] = useState({
    categories: true,
    brands: true,
    conditions: true,
    year: true,
    price: true,
    rarities: true,
    boxTypes: true,
  });
  const [showItemCounts, setShowItemCounts] = useState({
    category: 6,
    rarity: 6,
    condition: 6,
    boxType: 12,
  });

  const openCategories = {};

  const [searchParams, setSearchParams] = useAtom(searchParamsAtom);

  const [priceValue, setPriceValue] = useAtom(priceRangeAtom);
  const [yearValue, setYearValue] = useAtom(yearRangeAtom);
  const [categories, setCategories] = useState([]);
  const queries = new URLSearchParams(useLocation().search);
  const selectedCategories = queries.get("categories")
    ? queries.get("categories").split(",")
    : [];
  const selectedRarities = queries.get("rarities")
    ? queries.get("rarities").split(",")
    : [];
  const selectedBrands = queries.get("brands")
    ? queries.get("brands").split(",")
    : [];
  const selectedConditions = queries.get("conditions")
    ? queries.get("conditions").split(",")
    : [];
  const navigate = useNavigate();

  const [minYear, setMinYear] = useState(yearValue.min);
  const [maxYear, setMaxYear] = useState(yearValue.max);

  const [minPrice, setMinPrice] = useState(priceValue.min);
  const [maxPrice, setMaxPrice] = useState(priceValue.max);

  useEffect(() => {
    setMinYear(yearValue.min);
    setMaxYear(yearValue.max);
  }, [yearValue]);

  useEffect(() => {
    setMinPrice(priceValue.min);
    setMaxPrice(priceValue.max);
  }, [priceValue]);

  useEffect(() => {
    // getAllCategories(["active", "pending"]).then((items) => {
    getAllCategories(["active"]).then((items) => {
      //   console.log("categories", items);
      setCategories(items);
    });
  }, []);

  // Toggle function for each section
  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };
  const toggleCategory = (categoryId, subCategories) => {
    let temp = { ...searchParams };
    console.log({ temp });

    const index = temp.categories
      ? temp.categories.findIndex((item) => item.category === categoryId)
      : -1;
    if (index > -1) {
      temp.categories.splice(index, 1);
    } else {
      if (!temp.categories) {
        temp["categories"] = [
          { category: categoryId, subCategories: subCategories },
        ];
      } else {
        temp.categories.push({
          category: categoryId,
          subCategories: subCategories,
        });
      }
    }

    setSearchParams(temp);
  };

  const containCategory = (categoryId) => {
    if (!searchParams.categories) return false;
    if (
      searchParams.categories.findIndex(
        (item) => item.category === categoryId
      ) > -1
    )
      return true;
    return false;
  };

  const toggleSubCategory = (categoryId, subCat) => {
    let temp = { ...searchParams };
    let newCategories = [...temp["categories"]];
    if (containCategory(categoryId)) {
      newCategories = newCategories.reduce((acc, cur) => {
        if (cur.category === categoryId) {
          if (!cur.subCategories.includes(subCat)) {
            cur.subCategories.push(subCat);
          } else {
            const newSubCategories = cur.subCategories.reduce((acc1, cur1) => {
              if (cur1 !== subCat) acc1.push(cur1);
              return acc1;
            }, []);
            cur.subCategories = [...newSubCategories];
          }
        }

        if (cur.subCategories.length > 0) {
          acc.push(cur);
        }

        return acc;
      }, []);
    } else {
      if (newCategories.length > 0) {
        newCategories.push({ category: categoryId, subCategories: [subCat] });
      } else {
        newCategories = [{ category: categoryId, subCategories: [subCat] }];
      }
    }

    temp["categories"] = newCategories;
    setSearchParams(temp);
  };

  const containSubCategory = (categoryId, subCat) => {
    if (!searchParams.categories) return false;

    const index = searchParams.categories.findIndex(
      (item) => item.category === categoryId
    );

    if (index === -1) return false;

    if (searchParams.categories[index].subCategories.includes(subCat))
      return true;
    return false;
  };

  const handleShowItems = (tab) => {
    const temp = { ...showItemCounts };
    temp[tab] = Infinity;

    setShowItemCounts(temp);
    // setShowItems(...showItems, )
    // { showItemCounts = { ...showItemCounts, category: showItemCounts.category + 6 } }
  };

  const toggleRarity = (rarityId) => {
    let temp = { ...searchParams };
    const newRarities = [...temp.rarities];

    let index = newRarities.indexOf(rarityId);
    if (newRarities.includes(rarityId)) {
      newRarities.splice(index, 1);
    } else {
      newRarities.push(rarityId);
    }

    temp.rarities = [...newRarities];
    setSearchParams(temp);
  };

  const toggleBoxType = (boxTypeId) => {
    let temp = { ...searchParams };
    const newBoxTypes = [...temp.boxTypes];

    let index = newBoxTypes.indexOf(boxTypeId);
    if (newBoxTypes.includes(boxTypeId)) {
      newBoxTypes.splice(index, 1);
    } else {
      newBoxTypes.push(boxTypeId);
    }

    temp.boxTypes = [...newBoxTypes];
    setSearchParams(temp);
  };

  const toggleBrand = (brandValue) => {
    let newBrands = [];
    if (selectedBrands.includes(brandValue)) {
      newBrands = selectedBrands.filter((id) => id !== brandValue);
    } else {
      newBrands = [...selectedBrands, brandValue];
    }
    const categoryQuery = newBrands.join(",");

    navigate(`/marketplace/categories?brands=${categoryQuery}`);
  };

  const toggleCondition = (conditionValue) => {
    let temp = { ...searchParams };
    const newConditions = [...temp.conditions];

    let index = newConditions.indexOf(conditionValue);
    if (newConditions.includes(conditionValue)) {
      newConditions.splice(index, 1);
    } else {
      newConditions.push(conditionValue);
    }

    temp.conditions = [...newConditions];
    setSearchParams(temp);
  };

  const changeMinYear = (v) => {
    try {
      let currentValue = Number.parseInt(v.currentTarget.value);
      if (isNaN(currentValue)) {
        currentValue = 0;
      }
      if (currentValue >= 1900 && currentValue <= new Date().getFullYear()) {
        setYearValue({ min: currentValue, max: yearValue.max });
      }
      setMinYear(currentValue);
    } catch (e) {
      return;
    }
  };

  const changeMaxYear = (v) => {
    try {
      let currentValue = Number.parseInt(v.currentTarget.value);
      if (isNaN(currentValue)) {
        currentValue = 0;
      }
      if (currentValue >= 1990 && currentValue <= new Date().getFullYear()) {
        setYearValue({ min: yearValue.min, max: currentValue });
      }
      setMaxYear(currentValue);
    } catch (e) {
      return;
    }
  };

  const changeMinPrice = (v) => {
    try {
      let currentValue = Number.parseInt(v.currentTarget.value);
      if (isNaN(currentValue)) {
        currentValue = 0;
      }
      console.log(currentValue);
      if (
        currentValue >= 0 &&
        currentValue <= 500000 &&
        currentValue % 1000 === 0
      ) {
        setPriceValue({ min: currentValue, max: priceValue.max });
      }
      setMinPrice(currentValue);
    } catch (e) {
      return;
    }
  };

  const changeMaxPrice = (v) => {
    try {
      let currentValue = Number.parseInt(v.currentTarget.value);
      if (isNaN(currentValue)) {
        currentValue = 0;
      }
      if (
        currentValue >= 0 &&
        currentValue <= 500000 &&
        currentValue % 1000 === 0
      ) {
        setPriceValue({ min: priceValue.min, max: currentValue });
      }
      setMaxPrice(currentValue);
    } catch (e) {
      return;
    }
  };

  // Helper to format box type string
  const formatBoxType = (str) => {
    if (!str) return '';
    return str
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
};

  // Helper to capitalize each word
  const capitalizeWords = (str) => str.replace(/\b\w/g, c => c.toUpperCase());

  return (
    <div className={`w-full space-y-6 ${className}`}>
      <div className={`w-full`}>
        <div>
          <div
            className="w-full flex justify-between items-center cursor-pointer"
            onClick={() => toggleSection("categories")}
          >
            <span>Category</span>
            <img
              src="/assets/icons/icon-arrow-down-primary.svg"
              className={`${!openSections.categories ? "rotate-180" : ""}`}
            />
          </div>

          {openSections.categories && (
            <>
              <div className="flex flex-col items-center gap-5 mt-5">
                {categories.slice(0, showItemCounts.category).map((cat) => (
                  <div
                    key={cat.id}
                    className="w-[90%] mr-auto flex flex-col gap-3"
                  >
                    <div className="flex justify-between">
                      <button
                        className={`hover:border-primary w-full hover:text-white text-sm flex items-center`}
                        onClick={() => {
                          toggleCategory(cat.id, cat.subCategories);
                        }}
                      >
                        {containCategory(cat.id) ? (
                          <CheckedIcon />
                        ) : (
                          <UnCheckedIcon />
                        )}
                        <span className="ml-2">{cat.name}</span>
                      </button>

                      <button onClick={() => toggleSection(cat.id)}>
                        <img
                          src="/assets/icons/icon-arrow-down-white.svg"
                          className={`${
                            !openSections.categories ? "rotate-180" : ""
                          }`}
                        />
                      </button>
                    </div>

                    {openSections[cat.id] &&
                      cat.subCategories.map((subCat, index) => (
                        <div
                          className="flex justify-between w-[90%] mx-auto"
                          key={`${subCat}-${index}`}
                        >
                          <button
                            className={`hover:border-primary w-full hover:text-white text-sm flex items-center`}
                            onClick={() => toggleSubCategory(cat.id, subCat)}
                          >
                            {containSubCategory(cat.id, subCat) ? (
                              <CheckedIcon />
                            ) : (
                              <UnCheckedIcon />
                            )}
                            <span className="ml-2 text-[#858585]">
                              {capitalizeWords(subCat)}
                            </span>
                          </button>
                        </div>
                      ))}
                  </div>
                ))}
              </div>

              {categories.length > showItemCounts.category && (
                <button
                  className={`mt-6 solo-button uppercase bg-transparent text-xs  border-[#1AB6F940] border-[1px] rounded-[4px] w-full py-3`}
                  onClick={() => handleShowItems("category")}
                >
                  VIEW ALL CATEGORIES
                </button>
              )}
            </>
          )}
        </div>
      </div>

      <hr className="gradient-border my-8" />

      {/* <div className={`w-full`}>
        <div>
          <div
            className="w-full flex justify-between items-center cursor-pointer"
            // onClick={() => toggleSection("rarities")}
            onClick={() => toggleSection("rarities")}
          >
            <span>Rarity</span>
            <img
              src="/assets/icons/icon-arrow-down-primary.svg"
              className={`${!openSections.rarities ? "rotate-180" : ""}`}
            />
          </div>
          {openSections.rarities && (
            <div className="flex flex-col items-center gap-2 mt-5 lg:gap-4">
              {rarities.map((rarity) => (
                <button
                  className={`hover:border-primary w-full hover:text-white text-sm flex items-center`}
                  onClick={() => {
                    toggleRarity(rarity.value);
                  }}
                  key={`sidebar-rarity-${rarity.value}`}
                >
                  {searchParams.rarities.includes(rarity.value) ? (
                    <CheckedIcon />
                  ) : (
                    <UnCheckedIcon />
                  )}
                  <span className="ml-2">{rarity.label}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div> */}

      <div className={`w-full`}>
        <div>
          <div
            className="w-full flex justify-between items-center cursor-pointer"
            // onClick={() => toggleSection("boxTypes")}
            onClick={() => toggleSection("boxTypes")}
          >
            <span>Box Type</span>
            <img
              src="/assets/icons/icon-arrow-down-primary.svg"
              className={`${!openSections.boxTypes ? "rotate-180" : ""}`}
            />
          </div>
          {openSections.boxTypes && (
            <div className="flex flex-col items-center gap-2 mt-5 lg:gap-4">
              {boxTypes.map((boxType) => (
                <button
                  className={`hover:border-primary w-full hover:text-white text-sm flex items-center`}
                  onClick={() => {
                    toggleBoxType(boxType.value);
                  }}
                  key={`sidebar-rarity-${boxType.value}`}
                >
                  {searchParams.boxTypes.includes(boxType.value) ? (
                    <CheckedIcon />
                  ) : (
                    <UnCheckedIcon />
                  )}
                  <span className="ml-2">{formatBoxType(boxType.label)}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
      <hr className="gradient-border my-8" />

      <div className={`w-full`}>
        <div>
          <div
            className="w-full flex justify-between items-center cursor-pointer"
            onClick={() => toggleSection("conditions")}
          >
            <span>Condition</span>
            <img
              src="/assets/icons/icon-arrow-down-primary.svg"
              className={`${!openSections.conditions ? "rotate-180" : ""}`}
            />
          </div>
          {openSections.conditions && (
            <div className="flex flex-col items-center gap-2 mt-5 lg:gap-4">
              {conditions.map((condition) => (
                <button
                  className={`hover:border-primary w-full hover:text-white text-sm flex items-center`}
                  onClick={() => {
                    toggleCondition(condition.value);
                  }}
                  key={`sidebar-condition-${condition.value}`}
                >
                  {searchParams.conditions.includes(condition.value) ? (
                    <CheckedIcon />
                  ) : (
                    <UnCheckedIcon />
                  )}
                  <span className="ml-2">{formatBoxType(condition.label)}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      <hr className="gradient-border my-8" />

      <div className={`w-full`}>
        <div>
          <div
            className="w-full flex justify-between items-center cursor-pointer"
            onClick={() => toggleSection("year")}
          >
            <span>Year</span>
            <img
              src="/assets/icons/icon-arrow-down-primary.svg"
              className={`${!openSections.year ? "rotate-180" : ""}`}
            />
          </div>

          {openSections.year && (
            <>
              <div className="mt-7 mb-4">
                <div className="mx-2">
                  <InputRange
                    maxValue={new Date().getFullYear()}
                    minValue={1900}
                    step={1}
                    formatLabel={(v) => ``}
                    value={yearValue}
                    onChange={(v) => setYearValue(v)}
                  />
                </div>

                <div className="grid grid-cols-2 gap-5 justify-between w-full mt-6">
                  <div className="w-full">
                    <p className="text-white text-xs">FROM</p>
                    {/* <p className="text-xs mt-4 mb-4 text-white/60">{yearValue.min}</p> */}
                    <input
                      type="text"
                      className="text-xs mt-4 mb-4 text-white/60 bg-transparent font-['Aeonik']"
                      value={minYear}
                      onChange={changeMinYear}
                    />
                    <hr className="gradient-border w-full" />
                  </div>

                  <div className="w-full">
                    <p className="text-white text-xs">TO</p>
                    <input
                      type="text"
                      className="text-xs mt-4 mb-4 text-white/60 bg-transparent font-['Aeonik']"
                      value={maxYear}
                      onChange={changeMaxYear}
                    />
                    <hr className="gradient-border w-full" />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {!openSections.year && <hr className="gradient-border my-8" />}

      <div className={`w-full !mt-8`}>
        <div>
          <div
            className="w-full flex justify-between items-center cursor-pointer"
            onClick={() => toggleSection("price")}
          >
            <span>Price</span>
            <img
              src="/assets/icons/icon-arrow-down-primary.svg"
              className={`${!openSections.price ? "rotate-180" : ""}`}
            />
          </div>

          {openSections.price && (
            <>
              <div className="mt-7 mb-4">
                <div className="mx-2">
                  <InputRange
                    maxValue={500000}
                    minValue={0}
                    formatLabel={(v) => ``}
                    step={100}
                    value={priceValue}
                    onChange={(v) => setPriceValue(v)}
                  />
                </div>

                <div className="grid grid-cols-2 gap-5 justify-between w-full mt-6">
                  <div className="w-full">
                    <p className="text-white text-xs">FROM</p>
                    {/* <p className="text-xs mt-4 mb-4 text-white/60">$ {priceValue.min}</p> */}
                    <div className="flex gap-1">
                      <span className="text-xs mt-4 mb-4 text-white/60 bg-transparent font-['Aeonik']">
                        $
                      </span>
                      <input
                        type="text"
                        className="text-xs mt-4 mb-4 text-white/60 bg-transparent font-['Aeonik']"
                        value={minPrice}
                        onChange={changeMinPrice}
                      />
                    </div>
                    <hr className="gradient-border w-full" />
                  </div>

                  <div className="w-full">
                    <p className="text-white text-xs">TO</p>
                    {/* <p className="text-xs mt-4 mb-4 text-white/60">$ {priceValue.max}</p> */}
                    <div className="flex gap-1">
                      <span className="text-xs mt-4 mb-4 text-white/60 bg-transparent font-['Aeonik']">
                        $
                      </span>
                      <input
                        type="text"
                        className="inline-block text-xs mt-4 mb-4 text-white/60 bg-transparent font-['Aeonik']"
                        value={maxPrice}
                        onChange={changeMaxPrice}
                      />
                    </div>
                    <hr className="gradient-border w-full" />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        {!openSections.price && <hr className="gradient-border my-8" />}
      </div>
    </div>
  );
};

export default SidebarFilterMarketplaceCategories;
